/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/component-attach.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/component-attach.js":
/*!*********************************!*\
  !*** ./src/component-attach.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function () {
  "use strict";

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

  function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

  function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

  function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  var metricProvider = __webpack_require__(/*! ./provider */ "./src/provider/index.js");

  (function () {
    if (window.customElements && window.MutationObserver) {
      var config = {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      };
      var eventHandlers = {
        keypress: function keypress(event, params) {
          return params === null || event.key.toLocaleLowerCase() === params;
        }
      };

      var ComponentAttach =
      /*#__PURE__*/
      function (_HTMLElement) {
        _inherits(ComponentAttach, _HTMLElement);

        function ComponentAttach() {
          _classCallCheck(this, ComponentAttach);

          return _possibleConstructorReturn(this, _getPrototypeOf(ComponentAttach).call(this));
        }

        _createClass(ComponentAttach, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            var self = this;
            var providerType = self.getAttribute("provider-type") || "console";
            self.container = self.closest("component-container");
            self.useContainer = self.getAttribute("use-root-container") === "true";
            self.provider = new metricProvider[providerType](self.getAttribute("metric-name"));

            if (self.hasAttribute("event-start") && self.hasAttribute("component-start")) {
              var observer = new MutationObserver(function (mutations) {
                self.dettachStartComponent();
                self.startComponent = self.container.querySelectorAll(self.getAttribute("component-start"));

                if (self.startComponent) {
                  var startEvent = self.getAttribute("event-start").split(".")[0];
                  self.paramsTrigger = self.getAttribute("event-start").indexOf(".") > 0 ? self.getAttribute("event-start").split(".")[1] : null;

                  for (var selectorIndex = 0; selectorIndex < self.startComponent.length; selectorIndex++) {
                    self.allocatedStart = self.start.bind(self);
                    self.startComponent[selectorIndex].addEventListener(startEvent, self.allocatedStart);
                  }
                }
              });
              observer.observe(self.container, config);
            } else {
              self.start();
            }
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            this.dettachStartComponent();
          }
        }, {
          key: "dettachStartComponent",
          value: function dettachStartComponent() {
            if (this.startComponent && this.startComponent.length > 0) {
              for (var selectorIndex = 0; selectorIndex < this.startComponent.length; selectorIndex++) {
                this.startComponent[selectorIndex].removeEventListener(this.getAttribute("event-start"), this.allocatedStart);
              }
            }
          }
        }, {
          key: "start",
          value: function start(event) {
            var self = this;

            if (!event || !eventHandlers[event.type] || eventHandlers[event.type](event, self.paramsTrigger)) {
              self.provider.start();
            }

            self.observer = new MutationObserver(function (mutations) {
              var selector = self.getAttribute("component-end");
              var hasAllComponent = true;

              for (var mutationIndex = 0; mutationIndex < mutations.length && selector && hasAllComponent; mutationIndex++) {
                var nodeChanged = mutations[mutationIndex];

                if (nodeChanged.type !== "characterData") {
                  hasAllComponent = nodeChanged.target.matches(selector) || nodeChanged.target.querySelector(selector) !== null || self.useContainer && self.container.querySelector(selector) !== null;
                }
              }

              if (hasAllComponent && self.provider.started) {
                self.provider.end();
              }
            });
            self.observer.observe(self.container, config);
          }
        }], [{
          key: "observedAttributes",
          get: function get() {
            return [];
          }
        }]);

        return ComponentAttach;
      }(_wrapNativeSuper(HTMLElement));

      window.customElements.define("component-attach", ComponentAttach);
    }
  })();
});

/***/ }),

/***/ "./src/provider/console-provider.js":
/*!******************************************!*\
  !*** ./src/provider/console-provider.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function () {
  "use strict";

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  (function () {
    var ConsoleProvider =
    /*#__PURE__*/
    function () {
      function ConsoleProvider(eventName) {
        _classCallCheck(this, ConsoleProvider);

        this.started = false;
        this.eventName = eventName;
      }

      _createClass(ConsoleProvider, [{
        key: "start",
        value: function start() {
          if (!this.started) {
            this.startDate = new Date();
            this.started = true;
            console.log("Started ".concat(this.eventName, " on ").concat(this.startDate));
          }
        }
      }, {
        key: "end",
        value: function end() {
          if (this.started) {
            this.started = false;
            var endDate = new Date();
            var diff = endDate.getTime() - this.startDate.getTime();
            console.log("Finished ".concat(this.eventName, " on ").concat(endDate, " with ").concat(diff, " ms elapsed"));
          }
        }
      }]);

      return ConsoleProvider;
    }();

    module.exports = ConsoleProvider;
  })();
});

/***/ }),

/***/ "./src/provider/index.js":
/*!*******************************!*\
  !*** ./src/provider/index.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function () {
  "use strict";

  var newRelicProvider = __webpack_require__(/*! ./new-relic-provider */ "./src/provider/new-relic-provider.js");

  var consoleProvider = __webpack_require__(/*! ./console-provider */ "./src/provider/console-provider.js");

  module.exports = {
    "new-relic": newRelicProvider,
    "console": consoleProvider
  };
});

/***/ }),

/***/ "./src/provider/new-relic-provider.js":
/*!********************************************!*\
  !*** ./src/provider/new-relic-provider.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function () {
  "use strict";

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  (function () {
    var NewRelicProvider =
    /*#__PURE__*/
    function () {
      function NewRelicProvider(eventName) {
        _classCallCheck(this, NewRelicProvider);

        this.started = false;
        this.installed = true;
        this.eventName = eventName;

        if (typeof newrelic === "undefined") {
          console.warn("Newrelic not installed");
          this.installed = false;
        }
      }

      _createClass(NewRelicProvider, [{
        key: "start",
        value: function start() {
          if (this.installed && !this.started) {
            this.started = true;
            this.myInteraction = newrelic.interaction();
            this.myInteraction.setName(this.eventName);
            this.myInteraction.save();
          }
        }
      }, {
        key: "end",
        value: function end() {
          if (this.started) {
            this.started = false;
            this.myInteraction.end();
          }
        }
      }]);

      return NewRelicProvider;
    }();

    module.exports = NewRelicProvider;
  })();
});

/***/ })

/******/ });
//# sourceMappingURL=component-attach.js.map


// WEBPACK FOOTER //
// ./~/@octadesk/metric-component/dist/component-attach.js